import { render, staticRenderFns } from "./TheReport.vue?vue&type=template&id=0f505a87&"
import script from "./TheReport.vue?vue&type=script&lang=ts&"
export * from "./TheReport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports